mutation DeleteCharityCategory($id: ID!) {
  deleteCharityCategory(input: { id: $id }) {
    success
  }
}
